import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import './AccountModal.scss';
import Spinner from '../../../Spinner';
import axios from 'axios';
import moment from 'moment-timezone';
import { useUserContext } from '../../../../contexts/UserContext';
import UpdateEmail from './UpdateEmail';
import ChangePassword from './ChangePassword';
import Pool from '../../../../UserPool';
import { useNavigate } from 'react-router-dom';
import { useAreasContext } from '../../../../contexts/AreasContext';
import { wkt } from '../../../../usawkt';

export default function AccountModal(props) {
    const {
        setArea
    } = useAreasContext();

    const {
        user,
        config,
        setConfig,
        logout
    } = useUserContext();

    const {
        setEmail,
        priceID,
        modal,
        setModal,
        setPanel
    } = props;

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, serError] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);

    const signOut = async () => {
        logout();
        navigate('/login');
        setPanel({
            name: 'Empty',
            content: null
        });
        setArea({
            area_id: 1751,
            user_id: -1,
            area_name: "United States",
            area_description: "",
            geom: "0103000020E61000000100000004000000149598D04F5A59C07CEC6BB65F844340A08CA4F5CE7159C00C65EC0DE6D24240C4563D93A71B59C06605A2D4C0D44240149598D04F5A59C07CEC6BB65F844340",
            area_size_meters_squared: 0,
            created_timestamp: "2024-08-22 17:55:04.802192",
            zoom: 4,
            is_default: false,
            active: false,
            wkt: wkt,
            bounds: '-125.0,24.396308,-66.93457,49.384358'
        });
    }

    const cancelPlan = () => {
        setLoading(true);
        axios.delete(`https://firewatch-api.space-eyes.com/user/web-subscription?customer_id=${config.customerId}`, {
            headers: {
                'Authorization': `Bearer ${user.idToken.jwtToken}`
            }
        })
        .then((response) => {
            setLoading(false);
            setSuccessMessage('Your plan has been canceled successfully');
            console.log('data: ', response.data);
            signOut();
        }).catch((err) => {
            setLoading(false);
            serError(`Trouble canceling plan. Please try again. ${err}`)
            console.log('error canceling plan: ', err)
        })
    }

    const changePlan = () => {
        setLoading(true);
        axios.put(`https://firewatch-api.space-eyes.com/user/web-subscription?customer_id=${config.customerId}&price_id=${priceID}`, null, {
            headers: {
                'Authorization': `Bearer ${user.idToken.jwtToken}`
            }
        })
        .then((response) => {
            setLoading(false);
            setSuccessMessage('Your plan has been changed successfully');
            console.log('data: ', response.data)
            setConfig({
                ...config,
                subscription_type: response.data.subscription_type
            })
            setModal({
                type: false,
                content: null
            });
        }).catch((err) => {
            setLoading(false);
            serError(`Trouble changing plan. Please try again. ${err}`);
            console.log('error changing plan: ', err);
        })
    }

    const stageSwitch = (stage) => {
        switch (stage) {
            case 'update-email':
                return (
                    <UpdateEmail 
                        setModal={setModal}
                        user={user}
                        setEmail={setEmail}
                    />
                )
            case 'change-password':
                return (
                    <ChangePassword setModal={setModal}/>
                )
            case 'change-plan':
                return (
                    <div className='account-modal'>
                        <div className='account-modal-title'>Changing Plan</div>
                        <div className='account-modal-content-text'>Upgrading or downgrading your subscription will take effect immediately. Any remaining balance from your current plan will be applied to the new plan, and you may be charged or credited for the difference.</div> 
                        {error && <div className='account-modal-content-error'>{error}</div>}
                        {loading ?
                        <div style={{ paddingTop: '1rem' }}>
                            <Spinner />
                        </div>
                        :
                        <div className='account-modal-bottom-btns'>
                            <div 
                                className='account-modal-bottom-btns-btn-cancel'
                                onClick={() => {
                                    setModal({
                                        type: false,
                                        content: null
                                    })
                                }}>
                                Cancel
                            </div>
                            <button 
                                className='account-modal-bottom-btns-btn-save'
                                onClick={changePlan}
                                >
                                Confirm
                            </button>
                        </div>}
                    </div>
                ) 
            case 'cancel-plan':
                return (
                    <div className='account-modal'>
                        <div className='account-modal-title'>Canceling Plan</div>
                        <div className='account-modal-content-text'>Cancelling your subscription will stop automatic renewals. You will lose access to Space-Eyes FireWatch immediately. No refunds will be issued for the remaining time in this cycle.</div> 
                        {error && <div className='account-modal-content-error'>{error}</div>}
                        {loading ?
                        <div style={{ paddingTop: '1rem' }}>
                            <Spinner />
                        </div>
                        :
                        <div className='account-modal-bottom-btns'>
                            <div 
                                className='account-modal-bottom-btns-btn-cancel'
                                onClick={() => {
                                    setModal({
                                        type: false,
                                        content: null
                                    })
                                }}>
                                Cancel
                            </div>
                            <button 
                                className='account-modal-bottom-btns-btn-save'
                                onClick={cancelPlan}
                                >
                                Confirm
                            </button>
                        </div>}
                    </div>
                )
        }
    }

    return (
        <Dialog
            open={modal.type}
            onClose={() => {
                if (modal.type) {
                    setModal({
                        type: false,
                        content: null
                    })
                }
            }}
            PaperProps={{
                sx: {
                  backgroundColor: "white",
                }
              }}
        >
            {stageSwitch(modal.type)}
        </Dialog>
    )
}